import { GET_REFERAL_INFORMATION_SUCCESS } from "../actions/patientAction"


const getReferralDetailsReducer = (state = [], { type,  data = [] }) => {
    switch (type) {
      case GET_REFERAL_INFORMATION_SUCCESS:
        return data
      default:
        return state
    }
  }
  
  export default getReferralDetailsReducer